/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-no-bind */
// import { Dispatch, SetStateAction } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setStepDetails } from "src/redux/Actions/common";
import CustomButton from "../../../../shared/CustomButton";
import ReviewHeading from "../../../../shared/ReviewHeading";
import PrimaryReview from "./PrimaryReview";

// interface Props {
//   stepNo: number;
//   setStepNo: Dispatch<SetStateAction<number>>;
// }

function NomineeReview() {
  const dispatch = useDispatch();
  const reviewStepNumber = useAppSelector((state): any => state.stepDetails.reviewStepNo);
  function onBack() {
    // setStepNo(stepNo - 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber - 1 }));
    window.scrollTo(0, 0);
  }
  function onNext() {
    // setStepNo(stepNo + 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber + 1 }));
    window.scrollTo(0, 0);
  }
  return (
    <div className="lg:ml-24 lg:mr-24 max-sm:ml-4 md:max-lg:px-10 max-sm:mr-4  font-montserrat">
      <ReviewHeading label="Nominee Details" />
      <PrimaryReview />
      <div className="pb-10">
        <CustomButton onBack={onBack} onNext={onNext} />
      </div>
    </div>
  );
}
export default NomineeReview;
